<div class="company-select">
  <div class="user-contents ub ub-pb fw ub-ac" :class="isError ? 'is-error': ''">
    <div class="user-list ub ub-ac ub-ps fw">
      <span v-if="!value" >请选择</span>
      <a-tag class="ub fw" v-else closable color="blue" @close.prevent="removeSelected">{{ valueName }}</a-tag>
    </div>
    <div @click="showModal" class="add-icon" v-if="!value?.length">
      <img src="../../assets/images/icon_add.png" />
    </div>
    <div class="zhezhao" @click="showModal" v-if="!value?.length"></div>
  </div>
</div>
